import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Button, Popconfirm } from "antd";
import { getColorByScale } from "./colorUtils";

const CurrentStatusRight = React.memo(({ total, statusBreakup, handleShow, handleClickDownload, downloading }) => {
  const isDarkMode = typeof document !== 'undefined' && document.body && document.body.classList.contains('dark-theme');
  const centerTextColor = isDarkMode ? '#eeeef0' : '#0c0e10';
  const data = statusBreakup.map((status, index) => {
    if (status.jobs && status.jobs.length > 0 && total > 0) {
      const count = status.jobs && status.jobs.length || 0;
      const scale = Math.ceil((count / total) * 100);
      const { hex: color } = getColorByScale(scale);
      return {
        name: status._id || '',
        value: scale || 0,
        color
      }
    }
  });
  return (
    <div className="gx-text-center">
      <div className="gx-py-3">
        <h4 className="gx-mb-3 dash-card-title">Job Cards</h4>
        <p className="gx-text-muted">(awaiting today)</p>
        <ResponsiveContainer width="100%" height={150}>
          <PieChart>
            <Tooltip />
            <text
              x="50%" className="h1"
              y="50%" textAnchor="middle" dominantBaseline="middle" fill={centerTextColor}>
              {total}
            </text>
            {data && data.length ?
              (<Pie
                data={data} dataKey="value"
                cx="50%"
                cy="50%"
                innerRadius={47}
                outerRadius={57}
                fill="#8884d8"
              >
                {
                  data.map((entry, index) => <Cell key={index} fill={entry['color']} />)
                }
              </Pie>) : ''
            }
          </PieChart>
        </ResponsiveContainer>
        <div className="gx-mb-5 gx-mb-md-2">
          <Popconfirm
            title="Are you sure you want to download?"
            onConfirm={handleClickDownload}
            onCancel={null}
            okText="Yes"
            cancelText="No"
          >
            <Button className="gx-mr-2" type="primary" icon="download" loading={downloading}>Excel</Button>
          </Popconfirm>
          <Button className="gx-btn-cyan" icon='eye' onClick={handleShow}>Show</Button>
        </div>
      </div>
    </div>
  );
});
export default CurrentStatusRight;
